import { format } from "date-fns";

// const months = {
// 	0: "January",
// 	1: "February",
// 	2: "March",
// 	3: "April",
// 	4: "May",
// 	5: "June",
// 	6: "July",
// 	7: "August",
// 	8: "September",
// 	9: "October",
// 	10: "November",
// 	11: "December",
// };

export const formatDate = (dateStr) => {
	const date = new Date(dateStr);
	const formattedDate = format(date, "LLLL dd, yyyy HH:mm");

	return formattedDate;
};

export const getNow = () => {
	const now = new Date();
	const formattedDate = formatDate(now);

	return formattedDate;
};
